import { Link } from 'react-router-dom';
import { getCategories, buildCategoryPath } from '@/utils/articles';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '关于我们', to: '/about' },
  { label: '热门爆料', to: '/#hot' },
  { label: '今日更新', to: '/#latest' },
];

export default function Footer() {
  const categories = getCategories();

  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 font-heading text-base font-bold text-primary-700">
                18
              </span>
              <span className="font-heading text-xl font-bold text-background-50">爆料网</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              一个把"今日爆料"整理清楚的中文娱乐资讯站。明星动态、网红争议、素人投稿与圈内观察，每天都有新内容。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-base text-background-100">
                <i className="ri-wechat-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-base text-background-100">
                <i className="ri-weibo-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-base text-background-100">
                <i className="ri-mail-line" />
              </span>
            </div>
          </div>

          <nav aria-label="栏目导航">
            <h4 className="font-heading text-base font-semibold text-background-50">内容栏目</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={buildCategoryPath(category.slug)}
                    className="text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="快捷入口">
            <h4 className="font-heading text-base font-semibold text-background-50">快捷入口</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-background-300 transition-colors hover:text-accent-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">联系我们</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-send-line mt-0.5 text-base text-accent-400" />
                <span>投稿与线索：contact@18baoliao.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-error-warning-line mt-0.5 text-base text-accent-400" />
                <span>内容更正：correct@18baoliao.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-base text-accent-400" />
                <span>更新时间：每日 09:00 / 20:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 18爆料网 · 本站内容均为公开信息整理与网友投稿，仅供资讯参考。</p>
          <p>请理性围观，拒绝网络暴力，如涉侵权请联系我们删除。</p>
        </div>
      </div>
    </footer>
  );
}